import axios from 'axios'
import { store } from '../../redux'
import * as actions from '../../redux/features/storefront.redux'
import * as sessionActions from '../../redux/features/session.redux'
import * as customActions from '../../redux/features/custom.redux'
import routes from '../../../routes'
import { isAUDI, isVtiGiS } from '../../common/utils'
import { NavigateFunction } from 'react-router-dom';
import { pushStorefrontDataToDatalayer } from '../../analytics/storefront'
import { PartnerType } from '../../../models/enums'

const { REACT_APP_API_GATEWAY } = process.env

export const getStorefrontData = async (storefrontId: string) => {
  const url = `${REACT_APP_API_GATEWAY}/data/${storefrontId}`

  return axios.get(url, { validateStatus: (statusCode) => statusCode === 200 })
}

export const loadStorefrontDataToRedux = async (cid: string, navigate: NavigateFunction) => {
  store.dispatch(actions.storeId(cid))
  return internalLoadStorefrontDataToRedux(cid, navigate)
}

const internalLoadStorefrontDataToRedux = async (cid: string, navigate: NavigateFunction) => {
  store.dispatch(actions.pending())

  try {
    const response = await getStorefrontData(cid)
    const data = response.data

    store.dispatch(sessionActions.setTokenExpiresAt(data?.tokenExpiresAt));
    if (isVtiGiS(data) || isAUDI(data)) {
      store.dispatch(
        customActions.setServiceAndInspection(!!data?.custom?.serviceAndInspection)
      )
    }
    const updatedData = {
      ...data,
      ...(isVtiGiS(data) && data?.vehicleData?.hasEmployeeDiscount
        ? {
          ...data,
          customerData: {
            ...data?.customerData,
            partnerType: PartnerType.PRIVATE,
            storefrontPartnerType: PartnerType.PRIVATE,
          }
        }
        : {
          ...data,
          customerData: {
            ...data?.customerData,
            storefrontPartnerType: data?.customerData?.partnerType || PartnerType.PRIVATE
          }
        }
      ),
    }
    return store.dispatch(actions.initial(updatedData))

  } catch (error: any) {
    if (error?.response?.status === 409) {
      store.dispatch(
        actions.setRedirectUrl(error?.response?.data?.payload?.redirectUrl)
      )
      navigate(routes.vehicleNotAvailablePage)
    } else {
      store.dispatch(customActions.setErrorData({ url: window.location.href }));
      navigate(routes.errorPage)
    }
  }
}

export const updateStorefrontData = (data: any, storefrontData: any = store.getState().storefront.data) => {
  if (!data) {
    return;
  }
  const { custom, customerData, vehicleData, financialProduct, transaction, dealerData } = data;
  const dataToStore = {
    ...storefrontData,
    ...(custom && { custom: { ...storefrontData?.custom, ...custom } }),
    ...(customerData && { customerData: { ...storefrontData?.customerData, ...customerData } }),
    ...(vehicleData && { vehicleData: { ...storefrontData?.vehicleData, ...vehicleData } }),
    ...(financialProduct && { financialProduct: { ...storefrontData?.financialProduct, ...financialProduct } }),
    ...(transaction && { transaction: { ...storefrontData?.transaction, ...transaction } }),
    ...(dealerData && { dealerData: { ...storefrontData?.dealerData, ...dealerData } }),
  };
  store.dispatch(actions.done(dataToStore));
  pushStorefrontDataToDatalayer(dataToStore);
};
